import React from 'react'
import './index.less'
import { setLogin, goIndex, connectWebViewJavascriptBridge, getParams } from './../../../assets/js/utils'
import axios from 'axios'
import cx from 'classnames'

class ProductItem extends React.Component {
    constructor () {
        super()
        this.state = {
            value: 0
        }
    }

    // 跳转详情页
    skipToDetail = (items, index) => {
        const {
            data: { sublist, position, trackId },
            buriedPointEvent,
            activityId,
            websocket,
            activitySliderList
        } = this.props
        buriedPointEvent({
            button_name: `${trackId}-${items.productName}-详情`,
            button_id: `${items.id}`,
            button_order: `${index + 1}`,
            area_order: position,
            button_area: `${position}-${trackId}`
        })
        const { source } = getParams()
        if (sublist[0].isJumpDetailPage) {
            // ('gome_secondpage', location.protocol + '//' + location.host + url);
            if (source === 'app') {
                if (websocket && activitySliderList && activitySliderList[activitySliderList.length - 1].venueStatus !== 3) {
                    websocket.initiativeClose('跳详情页')
                }
                connectWebViewJavascriptBridge(JSBridge => {
                    JSBridge.callHandler('gome_secondpage', items.url + '?activityId=' + activityId)
                })
            } else {
                if (websocket && activitySliderList && activitySliderList[activitySliderList.length - 1].venueStatus !== 3) {
                    websocket.initiativeClose('跳详情页')
                }
                window.location.href = items.url + '?activityId=' + activityId
            }
        }
    }

    // 点击去抢购
    purchase = (item, index) => {
        const { buriedPointEvent, data: { sublist, trackId, position }, isLogin, businessLine, activityId, currentVenue, websocket } = this.props
        buriedPointEvent({
            button_name: `${trackId}-${item.productName}-去抢购`,
            button_id: `${item.id}`,
            button_order: `${index + 1}`,
            area_order: position,
            button_area: `${position}-${trackId}`
        })
        const { source } = getParams()
        const purchaseUrl = `${item.purchaseUrl}?activityId=${activityId}&venueId=${currentVenue.venueId}`
        this.setData(item)
        if (!sublist[0].isNeedLogin) {
            websocket.initiativeClose('去登录页面')
            goIndex(purchaseUrl)
            return
        }
        if (sublist[0].isNeedLogin) {
            if (isLogin) {
                if (sublist[0].isBeforeCheck) {
                    axios.get('/gateway/v1/activity/checkUserStatus', {
                        params: {
                            bankCode: item.bankCode,
                            productCode: item.productCode,
                            businessLine
                        }
                    })
                        .then(v => {
                            if (v.data.code === '200') {
                                if (v.data.data.authFlag === '0') {
                                    const authUrl = `${v.data.data.authUrl}/${item.bankCode}`
                                    if (source === 'app') {
                                        websocket.initiativeClose('去实名页面')
                                        connectWebViewJavascriptBridge(JSBridge => {
                                            JSBridge.callHandler('gome_secondpage', authUrl)
                                        })
                                    } else {
                                        websocket.initiativeClose('去实名页面')
                                        window.location.href = authUrl
                                    }
                                    return
                                }
                                if (v.data.data.openAccountFlag === '0') {
                                    const openAccountUrl = `${v.data.data.openAccountUrl}/${item.bankCode}`
                                    if (source === 'app') {
                                        websocket.initiativeClose('去开户页面')
                                        connectWebViewJavascriptBridge(JSBridge => {
                                            JSBridge.callHandler('gome_secondpage', openAccountUrl)
                                        })
                                    } else {
                                        websocket.initiativeClose('去开户页面')
                                        window.location.href = openAccountUrl
                                    }
                                    return
                                }
                                websocket.initiativeClose('去购买页')
                                goIndex(purchaseUrl)
                            }
                        })
                        .catch(err => {
                            console.log(err)
                        })
                } else {
                    websocket.initiativeClose('去购买页')
                    goIndex(purchaseUrl)
                }
            } else {
                websocket.initiativeClose('去登录页面')
                setLogin()
            }
        }
    }

    // 处理可售额度
    handleNum = (num) => {
        num = num.toString()
        const AMOUNT_REG = /(\d)(?=(?:(\d{3})|\d{3}\.\d+)+$)/g
        return num.replace(AMOUNT_REG, '$1,') + '元'
    }

    // 处理产品名称最多显示7个字剩下的...
    handleProductName = (data) => {
        if (data.length > 7) {
            const newData = data.slice(0, 6)
            return newData + '...'
        }
        return data
    }

    // 处理利率展示5.0%
    handleRate = (data) => {
        if (data.length === 1) {
            return data + '.0'
        }
        return data
    }

    // 存储cookie
    setData = (item) => {
        const { activityId, currentVenue } = this.props
        const purchaseUrl = window.encodeURIComponent(`${item.purchaseUrl}?activityId=${activityId}&venueId=${currentVenue.venueId}`)
        const { titleData } = this.props
        document.cookie = `maxActivityThemeColor=${titleData.maxActivityThemeColor}; path=/; domain=gomefinance.com.cn`
        document.cookie = `minActivityThemeColor=${titleData.minActivityThemeColor}; path=/; domain=gomefinance.com.cn`
        document.cookie = `activityThemeTextColor=${titleData.activityThemeTextColor}; path=/; domain=gomefinance.com.cn`
        document.cookie = `returnUrl=${purchaseUrl}; path=/; domain=gomefinance.com.cn`
    }

    getProductList = (value) => {
        this.setState({
            value
        })
    }

    render () {
        const { value } = this.state
        const { currentVenue, productList, data: { style } } = this.props
        let showProductList = productList.find(item => item.venueId === currentVenue.venueId).productList
        showProductList = value && showProductList.length > 6
            ? showProductList
            : showProductList.slice(0, 6)
        // 展示更多
        const moreProduct = (
            <div onClick={() => {
                this.getProductList(1)
            }} className={'foldItem'} >
                展开全部 <i className={'blueDownIconRow'} />
            </div>
        )
        // 展示更少
        const lessProduct = (
            <div onClick={() => {
                this.getProductList(0)
            }} className={'folditem'}>
                收起 <i className={'blueUpIconRow'} />
            </div>
        )
        // 产品列表
        const productListRender = (
            <React.Fragment>
                {
                    showProductList.map((item, index) => {
                        return (
                            <div
                                className='contentItemContainer statistics-dom'
                                key={index}
                            >
                                <p onClick={() => this.skipToDetail(item, index)}>
                                    <span>{item.bankName ? item.bankName : '--'} | {item.productName ? this.handleProductName(item.productName) : '--'}</span>
                                    {currentVenue.venueStatus === 1 && <span>可售额度：{item.totalQuota === null ? '--' : this.handleNum(parseInt(item.totalQuota))}</span>}
                                    {currentVenue.venueStatus === 2 && <span>剩余额度：{item.restQuota === null ? '--' : this.handleNum(parseInt(item.restQuota))}</span>}
                                    {currentVenue.venueStatus === 3 && <span></span>}

                                </p>
                                <div className={'contentItem'}>
                                    <div onClick={() => this.skipToDetail(item, index)}>
                                        <div className={'contentItemNum'}>
                                            <div>
                                                <p>{item.rate ? this.handleRate(item.rate) : '--'}<b>%</b></p>
                                                <p>{item.rateName}</p>
                                            </div>
                                            {item.addRate && <div className={'addRateStyle'}>
                                                <p>
                                                    <i>+</i>
                                                    <span>{item.addRate}</span>
                                                    <b>%<span style={{ background: style.addRateBackgroundColor || '#FFF' }}>加息{item.addRateTerm}天</span></b>
                                                </p>
                                                <p>{item.addRateName}</p>
                                            </div>}
                                            <div className={cx(!item.addRate ? 'contentItemRight' : null)}>
                                                <p><span>{item.introduce}</span></p>
                                                <p>{item.singleAmountMin}元起投</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {currentVenue.venueStatus === 1 && (
                                            <span style={{ background: style.buyBtnBackgroundColor || '#FFF', opacity: 0.7 }} onClick={() => {
                                                return false
                                            }}>未开始</span>)}
                                        {currentVenue.venueStatus === 2 && (item.restQuota > 0) && (
                                            <span style={{ background: style.buyBtnBackgroundColor || '#FFF' }} onClick={() => {
                                                this.purchase(item, index)
                                            }}>去抢购</span>)}
                                        {currentVenue.venueStatus === 2 && (item.restQuota <= 0) && (
                                            <span style={{ background: style.buyBtnBackgroundColor || '#FFF', opacity: 0.7 }} onClick={() => {
                                                return false
                                            }}>已抢光</span>)}
                                        {currentVenue.venueStatus === 3 && (
                                            <span style={{ background: style.buyBtnBackgroundColor || '#FFF', opacity: 0.7 }} onClick={() => {
                                                return false
                                            }}>已结束</span>)}
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </React.Fragment>
        )
        return (
            <React.Fragment>
                <div className={'contentContainer'} style={{ marginTop: `${style.paddingTop / 75}rem` || 0 }} >
                    {productList.find(item => item.venueId === currentVenue.venueId).productList.length > 0 ? productListRender : undefined}
                    {productList.find(item => item.venueId === currentVenue.venueId).productList.length > 6 ? (value ? lessProduct : moreProduct) : null}
                </div>
            </React.Fragment>
        )
    }
}

export default ProductItem
